import { baseURL } from "../../../../constants/commonConstants";
import { IFacultyDailyReports } from "../../../../models/faculty/facultyReports";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setReportsDaily } from "../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { ReportFrequency } from "../../../../models/dashboard/adminDashboard";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const DailyFacultyReports = (props: IFacultyDailyReports) => {
  const { snapShots, getDailyReports, dailyReports } = props;
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(ROUTER_URL.FACULTY_DAILY_REPORTS);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.facultyReports);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getDailyReports(
        pageBlockId.facultyReports,
        limit.three,
        ReportFrequency.Daily
      );
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReportsDaily([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Daily Reports</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="acc-resource row">
          {dailyReports?.map((report) => (
            <div className="col-lg-4">
              <a href={report.url} target="_blank">
                <div className="card d-flex align-items-start flex-column">
                  <div className="reportimg">
                    <img src={baseURL + report.icon} alt="" />
                  </div>
                  <h2 className="para-hide-1">{report.name}</h2>
                  <p className="para-hide-2">{report.description}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getDailyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    dailyReports: state.report.dailyreports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DailyFacultyReports);
